import { Card } from 'primereact/card';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

import { useEmployee } from '../context/employee';

function ValidateTokenPage() {
    const { pathname } = useLocation();
    const { deviceToken, employee, originalPath, ValidateToken } = useEmployee();

    const navigate = useNavigate();

    const [validating, setValidating] = useState(false);
    const [validated, setValidated] = useState(false);
    const [validationError, setValidationError] = useState('');

    // Validating - if not, then send the token for validation
    useEffect(() => {
        if (validated) {
            return;
        }

        if (validating) {
            return;
        }

        setValidating(true);

        ValidateToken({ token: deviceToken }, (res) => {
            setValidating(false);
            setValidated(true);

            if (res.status !== 200) {
                setValidationError(res.message);
                setTimeout(() => {
                    setValidationError('');
                }, 2000);
            }
        });
    }, [deviceToken, validated, validating, ValidateToken]);

    // Validation Error, send to sign in
    useEffect(() => {
        if (validationError) {
            setTimeout(() => {
                navigate('/sign-in');
            }, 2000);
        }
    }, [navigate, validationError]);

    const to = originalPath ? originalPath : '/';

    if (employee && to !== pathname) {
        return <Navigate to={to} />;
    }

    if (validationError) {
        return (
            <Card
                title="Token Validation Error"
                subTitle="Your token is invalid. Sending you to the sign in page"
                className="pageCard"
            >
                <p>{validationError}</p>
            </Card>
        );
    }

    return (
        <Card
            title="Token Validation"
            subTitle="Please wait while we confirm your app token"
            className="pageCard"
        >
            <ProgressSpinner />
        </Card>
    );
}

export default ValidateTokenPage;
